<template>
<layout-content>
  <template #toolbar>
    <data-time-query :query="query" />

    <site-query :sites="filterSites" :query="query" />

    <completed-query v-model="query.isAuditCompleted" @change="onAuditCompletedChanged" />

    <!-- <el-checkbox v-model="query.isMultipleIntegral" size="small" label="重积分" border v-if="query.isAuditCompleted !== false" /> -->

    <el-button
      :disabled="canNotSearch"
      type="orange"
      size="small"
      icon="el-icon-search"
      @click="onSearchBtnClick"
    >查询</el-button>
  </template>

  <template #body>
    <data-wrapper>
      <template #header>
        <unit-switch
          :default-unit-prop.sync="unitProp"
          @change="onUnitPropChange"
        />

        <dimension-type :default-dimension-type.sync="dimension" @change="onDimensionChanged" />
      </template>

      <x-y-chart
        v-for="data in dataList"
        v-if="data.dimensions.length > 0"
        :key="data.id"
        :data-config="data"
        :unit-prop="unitProp"
        chart-type="line"
        :stack-type="0"
        :download-name="downloadName"
        chart-min-height="400px"
        chart-height="auto"
        selected-change-with-data-changed
      />
    </data-wrapper>
  </template>
</layout-content>
</template>

<script>
import BaseSiteFactorData from '../../../BaseSiteFactorData'
import DeviceCategoryConfig from '../../../../model/DeviceCategoryConfig'

import LayoutContent from '../../../../components/Layout/Content'
import DataTimeQuery from '../../../../components/Data/Query/DataTimeQuery'
import SiteQuery from '../../../../components/Data/Query/SiteQuery'
import FactorTreeQuery from '../../../../components/Data/Query/FactorTreeQuery'
import CompletedQuery from '../../../../components/Data/Query/CompletedQuery'
import DataWrapper from '../../../../components/Data/DataWrapper'
import UnitSwitch from '../../../../components/Data/UnitSwitch'
import DisplayType from '../../../../components/Data/DisplayType'
import TrendRelatedChartWrapper from '../../../../components/Data/TrendRelatedChartWrapper'

export default {
  name: 'TimeChangeAnalysis',
  routeInfo: {
    label: '时间变化分析',
    icon: 'fa fa-users'
  },
  extends: BaseSiteFactorData,
  data: () => ({
    query: {
      factorIds: [],
      isMultipleIntegral: true
    }
  }),
  components: {LayoutContent, DataTimeQuery, SiteQuery, FactorTreeQuery, CompletedQuery, DataWrapper, UnitSwitch, DisplayType, TrendRelatedChartWrapper},
  computed: {
    siteDeviceCategoryConfig () {
      return [
        new DeviceCategoryConfig(process.env.CO2_DEVICE_CATEGORY, false, siteDeviceFactors => {
          return siteDeviceFactors.filter(el => el.parentId === 'a05000')
        }),
        new DeviceCategoryConfig(process.env.NMHC_DEVICE_CATEGORY, false, siteDeviceFactors => {
          return siteDeviceFactors.filter(el => el.parentId === 'a05000')
        }),
        new DeviceCategoryConfig(process.env.O3_DEVICE_CATEGORY, false, siteDeviceFactors => {
          return siteDeviceFactors.filter(el => el.parentId === 'a05000')
        })
      ]
    },
    downloadName: () => '时间变化分析'
  },
  methods: {
    getSeriesParam (dimension, dimensionIds) {
      return {
        type: 'line',
        showSymbol: false
      }
    },
    onDimensionChanged () {
      this.formatData()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/02GHGAnalysis/01TimeChangeAnalysis/index.vue